/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Conditional, Text, Space } from '@cashfree-intl/coherent';
import { copyToClipboard } from 'utils/common';
import CustomIcon from 'components/CustomIcons';
import { Action } from 'styles';
import {
  StyledCopyToClipboard,
  StyledDetailsContainer,
  StyledDetailsObject,
  StyledDisplayText,
  StyledPaper,
} from '../styled';
import { DATE_FIELDS, DETAILS_DISPLAY_TEXT_MAPPING } from '../constants';
import { formatDate } from '../helpers';

function VendorAccountDetails({
  vendorDeleted,
  accountDetailsObj,
  vendorId,
  onEditClickHandler,
}) {
  return (
    <StyledPaper>
      <Space direction="column">
        <Space justifyContent="space-between" alignItems="center">
          <Text variant="h16" strong className="mb-4">
            Account Details
          </Text>
          <Conditional if={!vendorDeleted}>
            <Button
              secondary
              size="small"
              onClick={() => onEditClickHandler('accountDetails')}
              data-event-name="Form_VendorAccountDetails_Button_Edit"
            >
              <CustomIcon componentName="EDIT" className="mr-1" />
              Edit
            </Button>
          </Conditional>
        </Space>
        <StyledDetailsContainer>
          {Object.keys(accountDetailsObj).map(obj => (
            <StyledDetailsObject key={obj} gap={5} className="mb-2">
              <StyledDisplayText variant="b14" color="bodyLight">
                {DETAILS_DISPLAY_TEXT_MAPPING[obj]}
              </StyledDisplayText>
              <Space gap={1} alignItems="center">
                <Text variant="b14">
                  {DATE_FIELDS.includes(obj)
                    ? formatDate(accountDetailsObj[obj])
                    : accountDetailsObj[obj]}
                </Text>
                {obj === 'merchantVendorId' && (
                  <StyledCopyToClipboard>
                    <Action>
                      <CustomIcon
                        componentName="COPY_TO_CLIPBOARD"
                        handleClick={copyToClipboard(vendorId)}
                      />
                    </Action>
                  </StyledCopyToClipboard>
                )}
              </Space>
            </StyledDetailsObject>
          ))}
        </StyledDetailsContainer>
      </Space>
    </StyledPaper>
  );
}

VendorAccountDetails.propTypes = {
  vendorDeleted: PropTypes.bool.isRequired,
  accountDetailsObj: PropTypes.object.isRequired,
  vendorId: PropTypes.string.isRequired,
  onEditClickHandler: PropTypes.func.isRequired,
};

export default VendorAccountDetails;
